import ProxyQuickConfiguration from './ProxyQuickConfiguration'
export default ProxyQuickConfiguration
